/* eslint-disable import/no-mutable-exports */
// Redux
import { configureStore, PreloadedState } from "@reduxjs/toolkit";
// Redux Thunk for having async action creators
import thunk from "redux-thunk";
// Reducers
import reducers from "./redux/reducers";

export type RootState = ReturnType<typeof reducers>;

const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).concat([thunk]),
    preloadedState,
  });

const store = setupStore();

export default store;
export { setupStore };
